import { Controller } from "@hotwired/stimulus"
import Inputmask from "inputmask"

export default class extends Controller {
  connect() {
    // Máscaras de data e hora
    if (this.element.classList.contains("datepicker")) {
      Inputmask("99/99/9999").mask(this.element)
    } else if (this.element.classList.contains("datetimepicker")) {
      Inputmask("99/99/9999 99:99").mask(this.element)
    } else if (this.element.classList.contains("timepicker")) {
      Inputmask("99:99").mask(this.element)
    }
    // Máscaras de número
    if (this.element.classList.contains("decimal")) {
      Inputmask("decimal", {
        alias: "numeric",
        groupSeparator: ".",
        radixPoint: ",",
        digits: 2,
        autoGroup: true,
        rightAlign: false,
        removeMaskOnSubmit: true // ensures Rails receives a clean numeric value
      }).mask(this.element)
    
    } else if (this.element.classList.contains("inteiro")){
      Inputmask("decimal", {
        alias: "numeric",
        groupSeparator: ".",
        radixPoint: ",",
        digits: 0,
        autoGroup: true,
        rightAlign: false,
        removeMaskOnSubmit: true // ensures Rails receives a clean numeric value
      }).mask(this.element)
    
    } else if (this.element.classList.contains("cep")){
      Inputmask("99999-999").mask(this.element)
    
    } else if (this.element.classList.contains("cpf")){
      Inputmask({
        mask: "999.999.999-99",
        }).mask(this.element);
        // Validando também
        this.element.addEventListener("input", () => {
        console.log(this.element.value)
        if (this.element.value.replace("_","").length < 14) {
          this.element.classList.remove("is-invalid");
        } else if (!this.validarCPF(this.element.value)) {
          this.element.classList.add("is-invalid");
        } else {
          this.element.classList.remove("is-invalid");
          this.element.classList.add("is-valid");
        }
      });
    } else if (this.element.classList.contains("cnpj")){
        Inputmask({
          mask: "AA.AAA.AAA/AAAA-99",
          definitions: {
            'A': {
              validator: "[a-zA-Z0-9]",
              casing: "upper"
            }
          }
        }).mask(this.element)
        // Validando também
        this.element.addEventListener("input", () => {
        console.log(this.element.value)
        if (this.element.value.replace("_","").length < 18) {
          this.element.classList.remove("is-invalid");
        } else if (!this.validarCNPJ(this.element.value)) {
          this.element.classList.add("is-invalid");
        } else {
          this.element.classList.remove("is-invalid");
          this.element.classList.add("is-valid");
        }
      });
    } else if (this.element.classList.contains("cpf-cnpj")) {
      // Definições de máscara:
      // Para o CNPJ, usamos 'Z' ou definimos um placeholder que aceite alfanumérico
      // No Inputmask, '9' é só número, 'A' é letra, '*' é alfanumérico.
      // '9' = apenas números
      // 'A' = letras e números (alfanumérico)
      const cpfMask  = "AAA.AAA.AAA-99";
      const cnpjMask = "AA.AAA.AAA/AAAA-99"; 

      const mask = new Inputmask({
        mask: [cpfMask, cnpjMask],
        keepStatic: true,     // IMPORTANTE: permite alternar entre as máscaras dinamicamente
        greedy: false,         // Não força a máscara mais longa imediatamente
        definitions: {
          'A': {
            validator: "[A-Za-z0-9]",
            casing: "upper"
          }
        }
      });

      mask.mask(this.element);

      this.element.addEventListener("input", () => {
      // Remove pontos, barras e traços, mas MANTÉM letras e números
      const valorLimpo = this.element.value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

      // Remove as cores de validação enquanto o usuário digita
      this.element.classList.remove("is-valid", "is-invalid");

      // Só valida se chegar nos tamanhos finais
      if (valorLimpo.length === 11) {
        // Valida CPF (garante que no CPF só tenha números)
        if (/^\d{11}$/.test(valorLimpo)) {
          const valido = this.validarCPF(valorLimpo);
          this.element.classList.add(valido ? "is-valid" : "is-invalid");
        }
      } 
      else if (valorLimpo.length === 14) {
        // Valida CNPJ (pode conter letras)
        const valido = this.validarCNPJ(valorLimpo);
        this.element.classList.add(valido ? "is-valid" : "is-invalid");
      }
    });

      // Listener extra para resetar ao apagar tudo (Backspace/Delete)
      this.element.addEventListener("keydown", (e) => {
        if (this.element.value === "") {
          this.element.classList.remove("is-valid", "is-invalid");
        }
      });
    } else if (this.element.classList.contains("telefone")) {
      const mask = new Inputmask({
        mask: [
          "(99) 9999-9999",
          "(99) 99999-9999"
        ],
        keepStatic: true,
        showMaskOnHover: false,
        showMaskOnFocus: false,
        clearIncomplete: true
      })

      mask.mask(this.element)
    }


  }

  validarCPF(cpf) {
    cpf = cpf.replace(/\D/g, "");

    if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

    let soma = 0;
    for (let i = 0; i < 9; i++)
      soma += parseInt(cpf.charAt(i)) * (10 - i);
    let digito1 = (soma * 10) % 11;
    if (digito1 === 10 || digito1 === 11) digito1 = 0;
    if (digito1 !== parseInt(cpf.charAt(9))) return false;

    soma = 0;
    for (let i = 0; i < 10; i++)
      soma += parseInt(cpf.charAt(i)) * (11 - i);
    let digito2 = (soma * 10) % 11;
    if (digito2 === 10 || digito2 === 11) digito2 = 0;

    return digito2 === parseInt(cpf.charAt(10));
  }

  validarCNPJ(cnpj) {
    // 1. Limpeza: Remove TUDO que não for letra ou número
    // Importante: Não use \D, pois ele remove as letras do novo CNPJ
    cnpj = cnpj.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

    // 2. Validação de tamanho e bloqueio de sequências repetidas
    if (cnpj.length !== 14 || /^([A-Z0-9])\1{13}$/.test(cnpj)) return false;

    // 3. Helper: Converte caractere para valor (0-9 e A-Z como 10-35)
    // Regra: código ASCII do caractere - 48
    const charToVal = (char) => char.charCodeAt(0) - 48;

    // 4. Cálculo do Primeiro Dígito (DV1)
    let peso = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let soma = 0;
    for (let i = 0; i < 12; i++) {
      soma += charToVal(cnpj.charAt(i)) * peso[i];
    }
    let resultado = soma % 11;
    let dv1 = resultado < 2 ? 0 : 11 - resultado;

    if (parseInt(cnpj.charAt(12)) !== dv1) return false;

    // 5. Cálculo do Segundo Dígito (DV2)
    peso = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    soma = 0;
    for (let i = 0; i < 13; i++) {
      soma += charToVal(cnpj.charAt(i)) * peso[i];
    }
    resultado = soma % 11;
    let dv2 = resultado < 2 ? 0 : 11 - resultado;

    return parseInt(cnpj.charAt(13)) === dv2;
  }

}

